import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

const requestHeaderTableData = {
  columns: [
    { Header: "S/N", accessor: "num", align: "left", width: "5%" },
    { Header: "Key", accessor: "key", align: "left", width: "25%" },
    { Header: "Value", accessor: "value", align: "left" },
  ],
  rows: [
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          1
        </MDTypography>
      ),
      key: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          x-client-initiated-request-timestamp
        </MDTypography>
      ),
      value: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
        </MDTypography>
      ),
    },
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          2
        </MDTypography>
      ),
      key: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          Authorization
        </MDTypography>
      ),
      value: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          {"Bearer <access_token>"}
        </MDTypography>
      ),
    },
  ],
};

const bodyColumnHeaders = [
  { Header: "S/N", accessor: "num", align: "left", width: "5%" },
  { Header: "Field", accessor: "field", align: "left", width: "15%" },
  { Header: "", accessor: "datatype", align: "center", width: "10%" },
  { Header: "Description", accessor: "description", align: "left" },
];

let tradingApiData = [
  {
    staticData: true,
    mainHeading: "Introduction",
    mainGridId: "introduction",
    mainHeadingDesc:
      "The Trading API ensures that buy/sell/short-sell order management is as easy as possible. Please follow the guidelines of the API and in case of any questions, please get in touch with relevant personnel within VCT Technologies LLC. ",
    mainHeadingDesc2:
      "This document should be utilized by users/clients/customers while designing their solutions.",
  },
  {
    staticDataTwo: true,
    mainHeading: "Environment",
    mainGridId: "environment",
    generalDescWithLinkOne: {
      desc: "To access the sandbox, please use the provided URL.",
      link: "https://demo.vtraderweb.com:6002/",
    },
    textOne: "In the document, this URL will be termed as",
    textTwo: "<base_url>",
    textThree: "All APIs will respond to data in application/JSON format.",
  },
  {
    mainHeading: "API Version",
    mainHeadingDesc: "For API release version v*.7.0.0 and above.",
    mainGridId: "api-version",
  },
  // Authorization Data
  {
    mainHeading: "Authorizations",
    mainHeadingDesc:
      "This section provides a guide on generating Access Tokens that allow access to the protected API endpoints. If the access token is invalid or expired, an error message with a 401 status code for unauthorized access pops up.",
    mainGridId: "authorizations",
  },
  {
    mainGridId: "request-access-token",
    subHeading: "Request Access Token",
    subHeadingDesc:
      "The Request Access Token endpoint can be used to request a new access token and a refresh token which is essential to keep the session alive.",
    endPointId: "request-access-token-request-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base_url>/connect/token",
    requestHeaderId: "request-access-token-request-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/x-www-form-urlencoded
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "request-access-token-request-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                grant_type<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Grant types are a way to specify how a client wants tointeract.
              The default value is "password" for this request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                client_id<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The client ID that is assigned to a user for login.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                username<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The username that is assigned to a user for login.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                password<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The password is provided to a user for login.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "request-access-token-success",
    respBody: "Response Body",
    respBodySuccessDesc: "",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              access_token
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Access Tokens are used to access authorized APIs.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              expires_in
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Access token expiry will be shown in seconds.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              token_type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies the type of token requested.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              refresh_token
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Refresh tokens allow requesting new access tokens without user
              interaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              scope
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies which APIs were accessed.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedDesc:
      "Access tokens expire after the time specified in the “Expires_in” property has elapsed. To get a new token without user interaction, use the Renew Access Token endpoint.",
    respBodyErrorId: "request-access-token-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              error
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies error name.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              error_description
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              A description of the type of error.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    respObjKey: "login_trading_api",
  },
  // Renew Access Token
  {
    mainGridId: "renew-access-token",
    subHeading: "Renew (Refresh) Access Token",
    subHeadingDesc:
      "Since access tokens have finite lifetimes, Renew Tokens allow requesting new access tokens without user interaction.",
    endPointHeading: "Request Endpoint",
    endPointId: "renew-access-token-request-endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base_url>/connect/token",
    requestHeaderId: "renew-access-token-request-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/x-www-form-urlencoded
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "renew-access-token-request-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                grant_type<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Grant Types are a way to specify how a client wants to
              interact.The default value is "refresh_token" for this request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                client_id<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The client ID that is assigned to a user for login.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                refresh_token<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Refresh Tokens are granted when requesting an access token API.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "renew-access-token-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              access_token
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Access Tokens are used to access authorized APIs.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              expires_in
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The Access Token expiry will be shown in seconds.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              token_type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of token requested.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              refresh_token
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Refresh tokens allow requesting new access tokens without user
              interaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              scope
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies which APIs were accessed.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "renew-access-token-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              error
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies the error name.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              error_description
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              A description of the type of error.
            </MDTypography>
          ),
        },
      ],
    },
  },

  // Static Accounts Data
  {
    mainGridId: "static-data",
    mainHeading: "Static Data",
    mainHeadingDesc:
      "Static Data provides essential information for the logged-in users such as the configured Accounts, Sides, TIFs, and more. This information is used in other API endpoint requests.",
  },
  {
    mainGridId: "static-data-accounts",

    // mainGridId: "static-data-accounts-endpoint",
    subHeading: "Accounts",
    subHeadingDesc:
      "The trading accounts assigned to a user can be retrieved using this endpoint.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "static-data-accounts-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/staticData/Account ",
    requestHeaderId: "static-data-accounts-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-accounts-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cmtas
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              CMTA number for the OCC.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              booth
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Account’s Booth ID.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-accounts-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_accounts",
  },
  // Sides Data
  {
    mainGridId: "static-data-sides",
    subHeading: "Sides",
    subHeadingDesc:
      "Using this endpoint, users can retrieve the order Sides allowed to them.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "static-data-sides-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/staticData/Side",
    requestHeaderId: "static-data-sides-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-sides-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-accounts-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_side",
  },
  // Time In Force Data
  {
    mainGridId: "static-data-time-in-force",
    subHeading: "Time In Force",
    subHeadingDesc:
      "Time In Force will show users the allowed time in force when placing an order. It specifies how long an order remains active. With no Time In Force specified, orders are interpreted as DAY orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "static-data-tif-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/staticData/TIF",
    requestHeaderId: "static-data-tif-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-tif-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-tif-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_tif",
  },
  // Order Type Data
  {
    mainGridId: "static-data-order-type",
    subHeading: "Order Type",
    subHeadingDesc:
      "The Order Types will show users the allowed order types, including Market, Limit, Stop, Stop Limit, etc. when creating orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "static-data-ot-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/staticData/OrdType",
    requestHeaderId: "static-data-ot-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-ot-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-ot-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_order_type",
  },
  // Locate Time In Force Data
  {
    mainGridId: "static-data-locate-time-in-force",
    subHeading: "Locate Time In Force",
    subHeadingDesc:
      "The Locate Time In Force will show users the allowed time in force when acquiring the locate. It specifies how long the Locate remains in effect. With no Locate Time In Force specified, the default is set as DAY.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "static-data-ltif-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/staticData/LocateTIF",
    requestHeaderId: "static-data-ltif-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-ltif-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-ltif-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_locate_tif",
  },
  // Destination Data
  {
    mainGridId: "static-data-destination",
    subHeading: "Destination",
    subHeadingDesc:
      "The Destination endpoint will give you the allowed destinations for placing an order.",
    endPointId: "static-data-dest-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/staticData/Destination",
    requestHeaderId: "static-data-dest-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-dest-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-dest-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_destination",
  },

  // Option Destination
  {
    mainGridId: "static-data-option-destination",
    subHeading: "Option Destination",
    subHeadingDesc:
      "The Option Destination endpoint will give you the allowed option destinations for placing an options order.",
    endPointId: "static-data-opt-dest-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/staticData/OptionDestination",
    requestHeaderId: "static-data-opt-dest-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-opt-dest-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-opt-dest-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_destination",
  },

  // Option Order Type
  {
    mainGridId: "static-data-opt-ord-type",
    subHeading: "Option Order Type",
    subHeadingDesc:
      "The Option Order Type endpoint will give you the allowed order types for placing an options order.",
    endPointId: "static-data-opt-ord-type-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/staticData/OptionOrdType",
    requestHeaderId: "static-data-opt-ord-type-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-opt-ord-type-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-opt-ord-type-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_destination",
  },

  // Option Time In Force
  {
    mainGridId: "static-data-opt-time-in-force",
    subHeading: "Option Time In Force",
    subHeadingDesc:
      "The Option Time in Force endpoint will give you the allowed time in force values for placing an options order.",
    endPointId: "static-data-opt-time-in-force-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/staticData/OptionTIF",
    requestHeaderId: "static-data-opt-time-in-force-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-opt-time-in-force-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-opt-time-in-force-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_destination",
  },

  // Put Call
  {
    mainGridId: "static-data-put-call",
    subHeading: "Put Call",
    subHeadingDesc:
      "The PutCall endpoint will give you the allowed Put/Call values for placing an options order.",
    endPointId: "static-data-put-call-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: " <base_url>/ext/ord/api/staticData/PutCall",
    requestHeaderId: "static-data-put-call-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-put-call-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-put-call-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_destination",
  },

  // Covered Uncovered
  {
    mainGridId: "static-data-covered-uncovered",
    subHeading: "Covered Uncovered",
    subHeadingDesc:
      "The Covered Uncovered endpoint will give you the allowed Covered/Uncovered values for placing an options order.",
    endPointId: "static-data-covered-uncovered-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: " <base_url>/ext/ord/api/staticData/CoveredUncovered",
    requestHeaderId: "static-data-covered-uncovered-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-covered-uncovered-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-covered-uncovered-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_destination",
  },

  // Covered Uncovered
  {
    mainGridId: "static-data-customer-firm",
    subHeading: "Customer Firm",
    subHeadingDesc:
      "The Customer Firm endpoint will give you the allowed Customer/Firm values for placing an options order.",
    endPointId: "static-data-customer-firm-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: " <base_url>/ext/ord/api/staticData/CustomerFirm",
    requestHeaderId: "static-data-customer-firm-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "static-data-customer-firm-body",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    // respBodySuccessDesc: "This endpoint ends a user's session after which you cannot renew the access token via refresh token.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              name
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The friendly name of each static value.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              value
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The value which will be used in other APIs.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "static-data-customer-firm-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
    respObjId: "token-connect-login-api",
    respObjKey: "static_data_destination",
  },

  // Add Order Data
  {
    mainGridId: "orders",
    mainHeading: "Orders",
    mainHeadingDesc:
      "The Orders APIs allow users to create, modify, and cancel orders. The input parameters for each API are defined below the respective endpoint. The allowed values for these input parameters can be fetched using the Static Data endpoint.",
    mainHeadingDesc2:
      "Updates related to the order such as executions and positions can be fetched using the Orders Subscription endpoints.",
  },
  {
    mainGridId: "orders-add-order",
    subHeading: "Add Order",
    subHeadingDesc:
      "Using this API, an order can be sent to the market or destination. The order parameters can be set according to the specifications mentioned in the request body.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointId: "orders-add-order-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/orders",
    requestHeaderId: "orders-add-order-req-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/json
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "orders-add-order-req-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                side<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                This includes the side of the order. Valid values:
                <ul className="bullets">
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                </ul>
                where, 1=Buy, 2=Sell, and 5=Sell short.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                orderQty<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order. Since this is a decimal type, any
              quantity entered with non-zero fractional part will be considered
              a fractional order. And quantity fractional values will be
              considered up to 6 decimal places only.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                symbol<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This represents the ticker symbol.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                ordType<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The type of order to be created. Valid values:
                <ul className="bullets">
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                  <li>"4"</li>
                </ul>
                where, 1=Market, 2=Limit, 3=Stop, 4=Stop limit.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price per share. This field is valid only with Limit & Stop
              Limit order types.
              <br />
              <br />
              Required: Conditional
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              stopPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specified stop price for the Order. The Stop Price field is valid
              only with Stop & Stop Limit order types.
              <br />
              <br />
              Required: Conditional
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account mnemonic as agreed between the broker and institution
              OR the account on behalf of which the order is to be placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                timeInForce<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies how long an order remains in effect. Valid values:
                <ul className="bullets">
                  <li>"0"</li>
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                  <li>"5"</li>
                  <li>"6"</li>
                </ul>
                where, 0=Day, 1=GTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID is used to represent this transaction for compliance purposes.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Auto-generated IDs for locates acquired outside of API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              contactName
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Name of the contact from where locates have been acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRequired
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              If true, an automated locate will be acquired from the Server.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The rate at which the automated locate will be acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The execution venue where the orders will be routed. When this
              field is not provided, the system will consider the default
              Destination value, which is configured at server.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              text
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Free format text string that specifies option order details with
              max length of 256 characters.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "orders-add-order-success",
    respBody: "Response Body",
    respBodySuccessDesc:
      "A successful request shows an “Order Successfully Created” message with a successful HTTP status code. ",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyAcceptedCodeId: "orders-add-order-accepted",
    respBodyAcceptedCode: "Status Code: 202 (Accepted)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              replyType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies the type of replies. Each value is as follows:
                <ul className="bullets">
                  <li>SERVER_REPLY_NONE,</li>
                  <li>SERVER_REPLY_WARNING, // OK|Cancel</li>
                  <li>SERVER_REPLY_QUESTION, // Yes|No</li>
                  <li>SERVER_REPLY_ERROR, // OK</li>
                  <li>SERVER_REPLY_SUCCESS</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              operation
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies the type of operations. Each value is as follows:
                <ul className="bullets">
                  <li>OPERATION_NONE = 0,</li>
                  <li>OPERATION_ETB_VALIDATION,</li>
                  <li>OPERATION_RESTRICTED_SYMBOL_VALIDATION,</li>
                  <li>OPERATION_LIMIT_VALIDATION,</li>
                  <li>OPERATION_LOCATE_QUOTE,</li>
                  <li>OPERATION_LOCATE</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              message
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This field will display the message as per the response.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              extraParamsAvailable
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This field shows whether any extra parameters are available.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              extraParams
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Extra parameters are specific to that error message.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "orders-add-order-bad",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code. If the field’s value is invalid, it shows validation error messages, below the specified body.",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of <br />
              errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "orders_orders" //Commenting this b/c we don't have proper response in JSON format
  },
  // Update Order Data
  {
    mainGridId: "orders-update-order",
    subHeading: "Update Order",
    subHeadingDesc:
      "The Update Order API allows the user to modify a previously placed order. ",
    endPointHeading: "Request Endpoint",
    endPointMethod: "PUT",
    endPointId: "orders-update-order-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/orders",
    requestHeaderId: "orders-update-order-req-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/json
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "orders-update-order-req-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>orderQty</>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order. Order modifications do not allow
              fractional quantities.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price per share. This field is valid only with Limit & Stop
              Limit order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>qOrderID</>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The ID of the order is to be updated, serving as a distinctive
              identifier for reference, tracking, order-modification, and
              cancellation. (It is deprecated, please use the orderID property
              instead)
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The stringified ID of the order is to be updated, serving as a
              distinctive identifier for reference, tracking,
              order-modification, and cancellation. Utilize the value for it
              from the subscription endpoint responses.
              <br />
              Required when qOrderID property is not provided.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>ordType</>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The type of order to be updated. Valid values:
                <ul className="bullets">
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                  <li>"4"</li>
                </ul>
                where, 1=Market, 2=Limit, 3=Stop, 4=Stop limit.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID used to represent this transaction for compliance purposes.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              stopPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specified stop price for the Order. The Stop Price field is valid
              only with Stop & Stop Limit order types.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "orders-update-order-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows an “Order Successfully Updated” message with a successful HTTP status code.",
    respBodyErrorId: "orders-update-order-bad",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code. If the field’s value is invalid, it shows validation error messages.",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "orders_cancel"  //Commenting this b/c we don't have proper response in JSON format
  },

  // Cancel Order Deprecated
  {
    mainGridId: "orders-cancel-order-deprecated",
    subHeading: "Cancel Order (Deprecated)",
    subHeadingDesc:
      "The Cancel Order API cancels the order that was previously placed. This endpoint is deprecated. It is recommended to utilize the new PATCH endpoint to cancel orders.",
    endPointId: "orders-cancel-order-deprecated-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "DELETE",
    endPointDesc: "<base_url>/ext/ord/api/orders/{qOrderID}",
    requestParamsId: "orders-cancel-order-deprecated-req-params",
    requestParams: "Request Params",
    requestParamsTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        {
          Header: "Param Name",
          accessor: "paramname",
          align: "left",
          width: "15%",
        },
        { Header: "", accessor: "datatype", align: "center", width: "10%" },
        { Header: "Description", accessor: "description", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          paramname: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The numbered ID of the order is to be canceled, and serves as a
              distinctive identifier for reference and tracking.
            </MDTypography>
          ),
        },
      ],
    },
    requestHeaderId: "orders-cancel-order-deprecated-req-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "orders-cancel-order-deprecated-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request will return an empty body with the respective HTTP status code.",
    respBodyErrorId: "orders-cancel-order-deprecated-bad",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "orders_cancel"  //Commenting this b/c we don't have proper response in JSON format
  },

  // Cancel Order Data
  {
    mainGridId: "orders-cancel-order",
    subHeading: "Cancel Order",
    subHeadingDesc: "API to cancel an order that was previously placed.",
    endPointId: "orders-cancel-order-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "PATCH",
    endPointDesc: "<base_url>/ext/ord/api/orders/cancel",
    requestParamsId: "orders-cancel-order-req-params",
    requestParams: "Request Params",
    requestParamsTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        {
          Header: "Param Name",
          accessor: "paramname",
          align: "left",
          width: "15%",
        },
        { Header: "", accessor: "datatype", align: "center", width: "10%" },
        { Header: "Description", accessor: "description", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          paramname: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                orderID<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The stringified ID of the order to be canceled, serves as a
              distinctive identifier for reference, tracking,
              order-modification, and cancellation. Utilize the value for it
              from the subscription endpoints responses.
            </MDTypography>
          ),
        },
      ],
    },
    requestHeaderId: "orders-cancel-order-req-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "orders-cancel-order-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows an “Order Successfully Cancelled” message with a successful HTTP status code.",
    respBodyErrorId: "orders-cancel-order-bad",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It will have errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "orders_cancel"  //Commenting this b/c we don't have proper response in JSON format
  },
  // Option Order Data
  {
    mainGridId: "option-orders",
    mainHeading: "Options Orders",
    mainHeadingDesc:
      "The Options Orders APIs allow users to create, modify, and cancel options orders. The input parameters for each API are defined below the respective endpoints. The allowed values for these input parameters can be fetched using the Static Data endpoint. For example, the Order Types API can be used to fetch the allowed order types.",
    mainHeadingDesc2:
      "	Updates related to the options orders such as executions and positions can be fetched using the Options Subscription endpoints.",
  },
  {
    mainGridId: "add-option-order",
    subHeading: "Add Options Order",
    subHeadingDesc:
      "	Using this API, an options order can be sent to the market or destination. The options orders' parameters can be set according to the specifications mentioned in the request body.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointId: "option-orders-add-options-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/optionorders",
    requestHeaderId: "option-orders-add-options-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/json
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "option-orders-add-options-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                side<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The side for the order of the options. Valid values:
                <ul className="bullets">
                  <li>"1"</li>
                  <li>"2"</li>
                </ul>
                where, 1=Buy, 2=Sell.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                orderQty<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order. Options order does not allow fractional
              quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                symbol<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the order will be placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                ordType<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The type of order to be created. Valid values:
                <ul className="bullets">
                  <li>"1"</li>
                  <li>"2"</li>
                </ul>
                where, 1=Market, 2=Limit. Options support only Market and Limit
                orders.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price per share. This field is valid only with Limit order
              type. Limit order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account mnemonic as agreed between the broker and institution
              OR the account on behalf of which the order is to be placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                timeInForce<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies how long an order remains in effect. Valid values:
                <ul className="bullets">
                  <li>"0"</li>
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                  <li>"5"</li>
                  <li>"6"</li>
                </ul>
                where, 0=Day, 1=GTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID is used to represent this transaction for compliance purposes.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Auto-generated IDs for locates acquired outside of Trading API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              contactName
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Name of the contact from where locates have been acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRequired
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              If yes, an automated locate will be acquired from the Server.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The rate at which the automated locate will be <br />
              acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              optionSymbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for the underlying equity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                strikePrice<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price at which the underlying equity can be exercised.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              expiryDate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The last day that the order is valid. (Valid for GTC/GTD orders)
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                maturityDate<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It indicates the date of maturity of an Options contract.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                putOrCall<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Each enum value is defined as:
                <ul className="bullets">
                  <li>"PUT"</li>
                  <li>"CALL"</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                putOrCall<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Each enum value is defined as:
                <ul className="bullets">
                  <li>"PUT"</li>
                  <li>"CALL"</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                customerOrFirm<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Each enum value is defined as:
                <ul className="bullets">
                  <li>"CUSTOMER"</li>
                  <li>"FIRM"</li>
                  <li>"CUST_BD"</li>
                  <li>"CUST_MM"</li>
                  <li>"NON_MEMBER_MM"</li>
                  <li>"FIRM_BD"</li>
                  <li>"PROPRIETARY_CUSTOMER"</li>
                  <li>"PROFESSIONAL_CUSTOMER"</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                coveredOrUnCovered<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Each enum value is defined as:
                <ul className="bullets">
                  <li>"COVERED"</li>
                  <li>"UN_COVERED"</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                cmta<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              CMTA number for the OCC. Its valid values can be fetched from
              accounts static data endpoint.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execBroker
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The executing broker for the options trade.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                openClose<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                This defines each enum value:
                <ul className="bullets">
                  <li>"OPEN"</li>
                  <li>"CLOSE"</li>
                </ul>
                Default OPEN, when not provided.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              24
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              optAttribute
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Char"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Can be used for SecurityType (167)=OPT to identify a particular
              security.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              25
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The execution venue where the orders will be routed. When this
              field is not provided, the system will consider the default
              configured destination.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              26
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              optionOrderText
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Free format text string that specifies option order details with
              max length of 256 characters.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "option-orders-add-options-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows an “Order successfully created” message with a successful HTTP status code.",
    respBodyAcceptedCodeId: "option-orders-add-options-accepted",
    respBodyAcceptedCode: "Status Code: 202 (Accepted)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              replyType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies the type of replies. Each value is as follows:
                <ul className="bullets">
                  <li>SERVER_REPLY_NONE,</li>
                  <li>SERVER_REPLY_WARNING, // OK|Cancel</li>
                  <li>SERVER_REPLY_QUESTION, // Yes|No</li>
                  <li>SERVER_REPLY_ERROR, // OK</li>
                  <li>SERVER_REPLY_SUCCESS</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              operation
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies the type of operations. Each value is as follows:
                <ul className="bullets">
                  <li>OPERATION_NONE = 0,</li>
                  <li>OPERATION_ETB_VALIDATION,</li>
                  <li>OPERATION_RESTRICTED_SYMBOL_VALIDATION,</li>
                  <li>OPERATION_LIMIT_VALIDATION,</li>
                  <li>OPERATION_LOCATE_QUOTE,</li>
                  <li>OPERATION_LOCATE</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              message
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This field shows the message relevant to the response.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              extraParamsAvailable
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This field shows if any extra parameters are available or not.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              extraParams
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Extra parameters are specific to that error message.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "option-orders-add-options-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "	A bad request shows an error message with a bad request HTTP status code. If the field’s value is invalid, it shows validation error messages.",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "option_order_post" //Commenting this b/c we don't have proper response in JSON format
  },
  // Option Orders Update Option order Data
  {
    mainGridId: "update-option-order",
    subHeading: "Update Options Order",
    subHeadingDesc:
      "The Update Options Order API allows users to modify previously placed options orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "PUT",
    endPointId: "option-orders-update-options-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/optionorders",
    requestHeaderId: "option-orders-update-options-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/json
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "option-orders-update-options-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>orderQty</>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It represents the total quantity of a financial instrument in the
              order. Order modifications do not allow fractional quantities.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Valid only with Limit order type. It denotes the price per unit of
              the financial instrument in the order, specifying the desired
              execution price, with interpretation influenced by the ordType
              (Order Type) field.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>qOrderID</>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The ID of the order is to be updated, serving as a distinctive
              identifier for reference, tracking, order-modification, and
              cancellation. (It is deprecated, please use the orderID property
              instead)
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                orderID<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The stringified ID of the order is to be updated, serving as a
              distinctive identifier for reference, tracking,
              order-modification, and cancellation. Utilize the value for it
              from the subscription endpoint responses. Required when qOrderID
              property is not provided.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>ordType</>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The type of order to be updated. Valid values:
                <ul className="bullets">
                  <li>"1"</li>
                  <li>"2"</li>
                </ul>
                where, 1=Market, 2=Limit.
                <br />
                Options order supports only Market and Limit orders.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID is used to represent the transaction for compliance purposes.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "option-update-add-options-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows an “Order successfully updated” message with the respective HTTP status code.",
    respBodyErrorId: "option-update-add-options-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code. If the field’s value is invalid, it shows validation error messages.",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "option_order_update" //Commenting this b/c we don't have proper response in JSON format
  },

  // Cancel Option Order (Deprecated)
  {
    mainGridId: "cancel-option-order-deprecated",
    subHeading: "Cancel Option Order (Deprecated)",
    subHeadingDesc: "The Cancel Order API cancels previously placed orders. ",
    endPointId: "cancel-option-order-deprecated-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "DELETE",
    endPointDesc: "<base_url>/ext/ord/api/optionorders/{qOrderID} ",
    requestParamsId: "cancel-option-order-deprecated-req-params",
    requestParams: "Request Params",
    requestParamsTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        {
          Header: "Param Name",
          accessor: "paramname",
          align: "left",
          width: "15%",
        },
        { Header: "", accessor: "datatype", align: "center", width: "10%" },
        { Header: "Description", accessor: "description", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          paramname: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The numbered ID of the order which is to be canceled, and serves
              as a distinctive identifier for reference and tracking.
            </MDTypography>
          ),
        },
      ],
    },
    requestHeaderId: "cancel-option-order-deprecated-req-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "cancel-option-order-deprecated-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows an “Order canceled successfully ” message with a successful HTTP status code.",
    respBodyErrorId: "cancel-option-order-deprecated-bad",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows the errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "orders_cancel"  //Commenting this b/c we don't have proper response in JSON format
  },

  // Cancel Option Order
  {
    mainGridId: "cancel-option-order",
    subHeading: "Cancel Option Order",
    subHeadingDesc: "To cancel an option order that was previously placed.",
    endPointId: "option-orders-cancel-options-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "PATCH",
    endPointDesc: "<base_url>/ext/ord/api/optionorders/cancel",
    requestBodyId: "option-orders-cancel-options-req-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [
        { Header: "S/N", accessor: "num", align: "left", width: "5%" },
        {
          Header: "Param Name",
          accessor: "paramname",
          align: "left",
          width: "15%",
        },
        { Header: "", accessor: "datatype", align: "center", width: "10%" },
        { Header: "Description", accessor: "description", align: "left" },
      ],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          paramname: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                qOrderID<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The stringified ID of the order that is to be canceled, serves as
              a distinctive identifier for reference, tracking,
              order-modification, and cancellation. Utilize the value for it
              from the subscription endpoint responses.
            </MDTypography>
          ),
        },
      ],
    },
    requestHeaderId: "option-orders-cancel-options-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "option-cancel-add-options-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows an “Order Successfully Cancelled” message with a successful HTTP status code.",
    respBodyErrorId: "option-cancel-add-options-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    // respBodyErrorDesc: "A bad request shows an error message with a bad request HTTP status code. If the field’s value is invalid then it shows validation error messages.",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It will have errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "option_order_cancel" //Commenting this b/c we don't have proper response in JSON format
  },

  // Locate Request
  {
    mainGridId: "locate-request",
    subHeading: "Locate Request",
    endPointId: "locate-request-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base_url>/ext/ord/api/locates",
    requestHeaderId: "locate-request-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/json
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "locate-request-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                symbol<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which users want to request the locate.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                orderQty<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order for which users would like to request the
              locate.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                price<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price for which the locate is requested.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                account<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the locate is requested.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "locate-request-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request will return an empty body with the respective HTTP status code. ",
    respBodyErrorId: "locate-request-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "locate_request" //Commenting this b/c we don't have proper response in JSON format
  },
  // Locate Request Data
  {
    mainGridId: "locate-acquire",
    subHeading: "Locate Acquire",
    endPointHeading: "Request Endpoint",
    endPointMethod: "POST",
    endPointDesc: "<base_url>/ext/ord/api/locates/acquire",
    endPointId: "locate-acquire-endpoint",
    requestHeaderId: "locate-acquire-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData: {
      columns: [...requestHeaderTableData.columns],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              x-client-initiated-request-timestamp
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"UTC DateTime with this format (dd/MM/yyyy HH:mm:ss:FFF)"}
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Content-Type
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              application/json
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          key: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Authorization
            </MDTypography>
          ),
          value: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              {"Bearer <access_token>"}
            </MDTypography>
          ),
        },
      ],
    },
    requestBodyId: "locate-acquire-body",
    requestBody: "Request Body",
    requestBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                quoteReqID<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Unique identifier for tracking Quote Request messages.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                symbol<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which users want to acquire the locate.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                orderQty<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity for an order for which users would like to acquire
              the locate.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                timeInForce<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies how long an order remains in effect. Valid values:
                <ul className="bullets">
                  <li>"0"</li>
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                  <li>"5"</li>
                  <li>"6"</li>
                </ul>
                where, 0=Day, 1=GTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              <>
                account<span style={{ color: "#ff4848" }}>*</span>
              </>
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The trading or customer account for which the locate is to be
              acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              synchronous
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Allowed values are: 0 and 1.
              <br />
              When 0: will respond without waiting for locate-acquire status.
              <br />
              When 1: will respond only when the locate-acquire status is
              received.
              <br />
            </MDTypography>
          ),
        },
      ],
    },
    respBodyId: "locate-acquire-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request will return an empty body with the respective HTTP status code.",
    respBodyErrorId: "locate-acquire-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              type
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the type of error reference.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              title
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the title of the error.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Integer"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the HTTP status code.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              traceId
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This shows the trace ID of the bad request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              errors
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows errors of multiple objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              5.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              [Error field name]
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array of String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              It shows multiple fields defined in the request body with a list
              of errors, if occurred.
            </MDTypography>
          ),
        },
      ],
    },
    respObjId: "token-connect-login-api",
    // respObjKey: "locate_acquire" //Commenting this b/c we don't have proper response in JSON format
  },
  // Locate Subscribe Data
  {
    mainGridId: "locates-subscribe",
    subHeading: "Locates Subscribe",
    subHeadingDesc:
      "The Subscribe endpoint will send users the locate updates from the Socket. The successful return of this API endpoint will give users the current state of the locates.",
    subHeadingDesc2: (
      <>
        Users must connect to the Signal R Hub or Web Socket Server for the
        subscription. The details on how to connect to the hub are available
        under
        <a href="#web-socket-hub-with-signalr"> Web Socket Hub with SignalR </a>
        or <a href="#web-socket-hub">Web Socket Hub</a>. There is a sample code
        along with the description, which users can refer to when subscribing to
        any of the methods.
      </>
    ),
    subHeadingImg: true,
    subHeadingImgDesc: (
      <>
        The Socket will receive updates through the{" "}
        <span className="staus-code">"Locates"</span> method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "locate-subscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/locates/subscribe",
    requestHeaderId: "locate-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "locate-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects. It indicates the type of order, such as
              Market, Limit, Stop, or others, specifying the instruction for
              executing the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order created, including Limit, Market, etc.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              quoteReqID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              A unique identifier is assigned to a Quote request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              statusDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The status description for the locates acquired:
                <ul className="bullets">
                  <li>"Open"</li>

                  <li>"Part Filled"</li>

                  <li>"Filled"</li>

                  <li>"Cancelled"</li>
                  <li>"Pending"</li>
                  <li>"Available"</li>
                  <li>"Not Available"</li>
                  <li>"Rejected"</li>
                  <li>"Part Consumed"</li>
                  <li>"Consumed"</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordStatus
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies Locate status:
                <ul className="bullets">
                  <li>"0"</li>
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                  <li>"4"</li>
                  <li>"5"</li>
                  <li>"6"</li>
                  <li>"7"</li>
                  <li>"8"</li>
                  <li>"9"</li>
                  <li>"10"</li>
                </ul>
                Where, 0 = Open, 1 = Part Filled, 2 = Filled, 4 = Cancelled, 5 =
                Pending, 6 = Available, 7 = Not Available, 8 = Rejected, 9 =
                Part Consumed, 10 = Consumed
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The locate quantity to be brought or sold in the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              offerPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price offered by the Locate Provider.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              offerSize
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The offer size proposed by the Locate Provider.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cumQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The last quantity of locates acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The total average price of the locates being filled.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordRejReason
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Reason for order rejection.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactionStatus
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Status of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies how long an order remains in effect.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              text
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              More details for the locate request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              id
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The unique ID of the locate request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which an order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              clientID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Friendly name of the account.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The "Time In Force" for the locate acquisition.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              boothID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Firm ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              etbQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The total quantity of locates available for consumption.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account ID on behalf of which the order is placed.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "locate-subscribe-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
  },
  // Locates UnSubscribe Data
  {
    mainGridId: "locates-unsubscribe",
    subHeading: "Locates Unsubscribe",
    subHeadingDesc:
      "	The Unsubscribe endpoint will stop sending locate updates to the Socket. Users will stop receiving updates of locates.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/locates/unsubscribe",
    endPointId: "locate-unsubscribe-endpoint",
    requestHeaderId: "locate-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "locate-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "	A successful request shows the message, “Success!” with the respective HTTP status code.",
  },
  // Locates Unsubscribe Data
  {
    mainGridId: "locates-summary-subscribe",
    subHeading: "Locates Summary Subscribe",
    subHeadingDesc:
      "	The Subscribe endpoint will send users the locate summary updates from Socket. The successful return of this API endpoint will give users the current state of the locates summary.",
    subHeadingDesc2: (
      <>
        Users must connect to the SignalR Hub or Web Socket Server for the
        subscription. The details on how to connect to the hub are available
        under
        <a href="#web-socket-hub-with-signalr-endpoint">
          Web Socket Hub with SignalR
        </a>
        or <a href="#web-socket-hub-endpoint">Web Socket Hub</a>. There is a
        sample code along with the description, which users can refer to when
        subscribing to any of the methods.
      </>
    ),
    subHeadingImg: true,
    subHeadingImgDesc: (
      <>
        The Socket will receive updates through the
        <span className="staus-code">"LocateSummary"</span> method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "locate-summary-subscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/locates/summary/subscribe",
    requestHeaderId: "locate-summary-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "locate-summary-subscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              id
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The unique ID of the locate request.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which an order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              clientID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Friendly name of the account.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The "Time In Force" for the locate acquisition.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              boothID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Firm ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              etbQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The total quantity of locates available for consumption.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account ID on behalf of which the order is placed.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyAcceptedCodeId: "locate-summary-subscribe-no-content",
    respBodyAcceptedCode: "Status Code: 204 (No Content)",
    respBodyAcceptedDesc:
      "The 204 status code shows up when an empty body returns with no data.",
  },
  // Locates Summary UnSubscribe Data
  {
    mainGridId: "locates-summary-unsubscribe",
    subHeading: "Locates Summary Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending locate summary updates to the Socket. Users will stop receiving updates of locate summary.",
    endPointHeading: "Request Endpoint",
    endPointId: "locate-summary-unsubscribe-endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/locates/summary/unsubscribe",
    requestHeaderId: "locate-summary-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "locate-summary-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "	A successful request shows the message, “Success!” with the respective HTTP status code.",
  },
  // Locates Summary Unsubscribe Data
  {
    mainGridId: "orders-subscriptions",
    subHeading: "Orders Subscriptions",
    subHeadingDesc:
      "Users can subscribe and unsubscribe to multiple types of orders, as listed below under separate APIs.",
    subHeadingDesc2: (
      <>
        Users must connect to the SignalR Hub or Web Socket Server for the
        subscription. The details on how to connect to the hub are available
        under{" "}
        <a href="#web-socket-hub-with-signalr-endpoint">
          Web Socket Hub with SignalR{" "}
        </a>
        or <a href="#web-socket-hub-endpoint">Web Socket Hub</a>. There is a
        sample code along with the description, which users can refer to when
        subscribing to any of the methods.
      </>
    ),
    subHeadingImg: true,
    subHeadingImgDesc: (
      <>
        The updates will be sent to the Socket through the{" "}
        <span className="staus-code">"Orders"</span> method.
      </>
    ),
  },
  // Orders Subscriptions Data
  {
    mainGridId: "order-subscribe",
    subHeading: "Orders Subscribe",
    subHeadingDesc:
      "The Orders Subscribe endpoint will send users the orders updates from the Socket. The successful return of this API endpoint will give users the current state of orders.",
    subHeadingDesc2:
      'The updates will be sent to the Socket through the "Orders" method.',
  },
  {
    mainGridId: "order-subscribe",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "orders-subscribes-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/subscription/orders/subscribe",
    requestHeaderId: "orders-subscribes-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "orders-subscribes-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyErrorId: "orders-subscribes-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The ID for the created order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This uniquely identifies an order for reference, tracking,
              order-modification, and cancellation.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price on which the order was created. The field is valid for
              Limit orders only, and 0 for other order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which an order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              sideDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including BUY or SELL or SS (SHORTSELL).
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              statusDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The status description for the created order:
                <ul className="bullets">
                  <li>"Open"</li>

                  <li>"Active"</li>

                  <li>"Rejected"</li>
                  <li>"Part Fill"</li>
                  <li>"Filled"</li>
                  <li>"Pending Cxl"</li>
                  <li>"Cancelled"</li>
                  <li>"Manual Cxl"</li>
                  <li>"Pending Rpl"</li>
                  <li>"Expired"</li>
                  <li>"DFD"</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The status description for the created order:
                <ul className="bullets">
                  <li>"Open"</li>

                  <li>"Active"</li>

                  <li>"Rejected"</li>
                  <li>"Part Fill"</li>
                  <li>"Filled"</li>
                  <li>"Pending Cxl"</li>
                  <li>"Cancelled"</li>
                  <li>"Manual Cxl"</li>
                  <li>"Pending Rpl"</li>
                  <li>"Expired"</li>
                  <li>"DFD"</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              text
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Free format text string that specifies order details such as
              reasons for order rejection.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              side
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              “1”
              <br />
              “2”
              <br />
              “5”
              <br />
              where, 1=BUY, 2=SELL, 5=SHORTSELL
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order created, including Limit, Market, etc.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              stopPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The Stop Price field only valid for Stop & Stop Limit order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies how long an order remains in effect. Valid values:
                <ul className="bullets">
                  <li>"0"</li>
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                  <li>"5"</li>
                  <li>"6"</li>
                </ul>
                where, 0=Day, 1=GTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              clOrdID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              FIX client order ID assigned by the institution.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              tifDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of time in force.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderTypeDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of order type.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Average price of the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cumQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total filled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              workableQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total workable quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              leavesQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Unfilled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.24
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolWithoutSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.25
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID is used to represent this transaction for compliance purposes.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.26
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Auto-generated IDs for the locates acquired outside of Trading API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.27
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              contactName
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Name of the contact from where the locates have been acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.28
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRequired
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              If true, an automated locate will be acquired from the Server.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.29
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The rate at which the automated locate will be acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.30
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Destination using which the order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.31
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.32
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              rule80A
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Rule80A code indicating account classification for reporting.
            </MDTypography>
          ),
        },
      ],
    },
  },
  // Orders Unsubscribe
  {
    mainGridId: "orders-unsubscribe",
    subHeading: "Orders Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending orders' updates to the Socket. Users will stop receiving updates on orders.",
    endPointId: "orders-unsubscribes-endpoint",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/subscription/orders/unsubscribe",
    requestHeaderId: "orders-unsubscribes-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "orders-unsubscribes-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code. ",
    respBodyErrorId: "orders-unsubscribes-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Orders Unsubscribe Data
  {
    mainGridId: "option-orders-subscribe",
    subHeading: "Options Orders Subscribe",
    subHeadingDesc:
      "The Subscribe endpoint will send users the options orders' updates from the Socket. The successful return of this API endpoint will give users the current state of options orders. ",
    subHeadingDesc2: (
      <>
        The Socket will receive updates through the
        <span className="staus-code"> "OptionOrders” </span> method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/subscription/optionorders/subscribe",
    endPointId: "option-orders-subscribe-endpoint",
    requestHeaderId: "option-orders-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "option-orders-subscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              QuickFIX identifier for an options order. It uniquely identifies
              the order within the system.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Sting"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This uniquely identifies an order for reference, tracking,
              order-modification, and cancellation.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price on which the order was created. Valid for Limit orders
              only, 0 for other order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which an order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              sideDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including BUY or SELL.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              statusDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including BUY or SELL.
              <ul className="bullets">
                <li>"Open"</li>

                <li>"Active"</li>

                <li>"Rejected"</li>
                <li>"Part Fill"</li>
                <li>"Filled"</li>
                <li>"Pending Cxl"</li>
                <li>"Cancelled"</li>
                <li>"Manual Cxl"</li>
                <li>"Pending Rpl"</li>
                <li>"Expired"</li>
                <li>"DFD"</li>
              </ul>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The status description for the created order:
                <ul className="bullets">
                  <li>"Open"</li>

                  <li>"Active"</li>

                  <li>"Rejected"</li>
                  <li>"Part Fill"</li>
                  <li>"Filled"</li>
                  <li>"Pending Cxl"</li>
                  <li>"Cancelled"</li>
                  <li>"Manual Cxl"</li>
                  <li>"Pending Rpl"</li>
                  <li>"Expired"</li>
                  <li>"DFD"</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              text
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Free format text string that specifies order details such as
              reasons for order rejection.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              side
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                <ul className="bullets">
                  <li> “1“</li>

                  <li>“2“</li>
                </ul>
                where 1 = BUY or 2 = SELL.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order created, including Limit or Market.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              stopPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The Stop Price field is only valid with Stop & Stop Limit order
              types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies how long an order remains in effect. Valid values:
                <ul className="bullets">
                  <li>"0"</li>
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                  <li>"5"</li>
                  <li>"6"</li>
                </ul>
                where, 0=Day, 1=GTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              clOrdID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              FIX client order ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              tifDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of time in force.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderTypeDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of order type.
            </MDTypography>
          ),
        },

        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Average price of the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cumQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total filled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              workableQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total workable quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              leavesQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Unfilled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.24
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolWithoutSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.25
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID used to represent this transaction for compliance purposes.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.26
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Auto-generated IDs for locates acquired outside of Trading API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.27
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              contactName
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Name of the contact from where locates have been acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.28
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRequired
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              If yes, an automated locate will be acquired from the Server.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.29
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The rate at which the automated locate will be acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.30
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              optionSymbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for the underlying equity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.31
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              strikePrice
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price at which the underlying equity can be exercised.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.32
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              maturityDay
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Int"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The last day on which the options can be exercised into the
              underlying equity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.33
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              maturityMonthYear
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Month and Year for the Maturity Day.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.34
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              putOrCall
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Each enum value is defined as:
                <ul className="bullets">
                  <li>“PUT”</li>

                  <li>“CALL”</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.35
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              customerOrFirm
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Each enum value is defined as:
                <ul className="bullets">
                  <li>“CUSTOMER”,</li>
                  <li>“FIRM”,</li>
                  <li>“CUST_BD”,</li>
                  <li>“CUST_MM”,</li>
                  <li>“NON_MEMBER_MM”,</li>
                  <li>“FIRM_BD”,</li>
                  <li>“PROPRIETARY_CUSTOMER”,</li>
                  <li>“PROFESSIONAL_CUSTOMER”</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.36
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              coveredOrUncovered
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Each enum value is defined as:
                <ul className="bullets">
                  <li>“COVERED”</li>

                  <li>“UN_COVERED”</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.37
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cmta
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              CMTA number for the OCC.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.38
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execBroker
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Exec broker is the executing broker.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.39
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              openClose
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This defines each enum value:
              <br />
              “OPEN=O”, “CLOSE=C”
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.40
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Destination using which the order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.41
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.42
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              rule80A
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Rule80A code indicating account classification for reporting.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "option-orders-subscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Option Orders Subscribe Data
  {
    mainGridId: "option-orders-unsubscribe",
    subHeading: "Options Orders Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending options orders' updates to the Socket. Users will stop receiving updates on the options orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "option-orders-subscribe-endpoint",
    endPointDesc:
      "<base_url>/ext/ord/api/subscription/optionorders/unsubscribe",
    requestHeaderId: "option-orders-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "option-orders-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code.",
    respBodyErrorId: "option-orders-unsubscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Option Orders Unsubscribe Data
  {
    mainGridId: "open-orders-subscribe",
    subHeading: "Open Orders Subscribe",
    subHeadingDesc:
      "The Subscribe endpoint will send users the open orders' updates from Socket. The successful return of this API endpoint will give users the current state of open orders. ",
    subHeadingDesc2: (
      <>
        The Socket will receive updates through the
        <span className="staus-code">
          <i>"OpenOrders"</i>
        </span>
        method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "open-orders-subscribe-endpoint",
    endPointDesc: "BBB<base_url>/ext/ord/api/subscription/openorders/subscribe",
    requestHeaderId: "open-orders-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "open-orders-subscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Array
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Long"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The ID for the created order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This uniquely identifies an order for reference, tracking,
              order-modification, and cancellation.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price on which the order was created. Valid for Limit order, 0
              for other order types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which an order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              sideDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including BUY or SELL or SS (SHORTSELL).
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              statusDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The status description for the created order:
                <ul className="bullets">
                  <li>"Open"</li>

                  <li>"Active"</li>

                  <li>"Rejected"</li>
                  <li>"Part Fill"</li>
                  <li>"Filled"</li>
                  <li>"Pending Cxl"</li>
                  <li>"Cancelled"</li>
                  <li>"Manual Cxl"</li>
                  <li>"Pending Rpl"</li>
                  <li>"Expired"</li>
                  <li>"DFD"</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              status
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The status description for the created order:
                <ul className="bullets">
                  <li>"Open"</li>

                  <li>"Active"</li>

                  <li>"Rejected"</li>
                  <li>"Part Fill"</li>
                  <li>"Filled"</li>
                  <li>"Pending Cxl"</li>
                  <li>"Cancelled"</li>
                  <li>"Manual Cxl"</li>
                  <li>"Pending Rpl"</li>
                  <li>"Expired"</li>
                  <li>"DFD"</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              text
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Free format text string that specifies order details such as
              reasons for order rejection.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              side
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                <ul className="bullets">
                  <li> “1”</li>

                  <li>“2”</li>

                  <li>“5”</li>
                </ul>
                where, 1=BUY, 2=SELL, 5=SHORTSELL
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The type of order created, including Limit, Market, etc.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              stopPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The Stop Price field is only valid with Stop & Stop Limit order
              types.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies how long an order remains in effect. Valid values:
                <ul className="bullets">
                  <li>"0"</li>
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                  <li>"5"</li>
                  <li>"6"</li>
                </ul>
                where, 0=Day, 1=GTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              clOrdID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              FIX client order ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              tifDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of time in force.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderTypeDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of order type.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Average price of the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cumQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total filled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              workableQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total workable quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              leavesQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Unfilled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.24
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolWithoutSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.25
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              complianceID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              ID used to represent this transaction for compliance purposes.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.26
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Auto-generated IDs for the locates acquired outside of Trading API.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.27
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              contactName
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Name of the contact from where the locates have been acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.28
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRequired
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Boolean"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              If yes, an automated locate will be acquired from the Server.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.29
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              locateRate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The rate at which the automated locate will be acquired.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.30
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Destination using which the order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.31
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.32
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              rule80A
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Rule80A code indicating account classification for reporting.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "open-orders-subscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code. ",
  },
  // Open Orders Unsubscribe
  {
    mainGridId: "open-orders-unsubscribe",
    subHeading: "Open Orders Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending open orders' updates to the Socket. Users will stop receiving updates on the open orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "open-orders-unsubscribe-endpoint",
    endPointDesc:
      "<base_url>/ext/ord/api/subscription/openorders/unsubscribe",
    requestHeaderId: "open-orders-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "open-orders-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code.",
    respBodyErrorId: "open-orders-unsubscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Option Orders Unsubscribe Data
  {
    mainGridId: "executions-subscribe",
    subHeading: "Executions Subscribe",
    subHeadingDesc:
      "The subscribe endpoint will send you the executions updates from the Web Socket. The successful return of this API endpoint will give you the current executions.",
    subHeadingDesc2: (
      <>
        The socket will receive updates through the
        <span className="staus-code"> "Executions"</span> method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointId: "executions-subscribe-endpoint",
    endPointMethod: "GET",
    endPointDesc: "<base_url>/ext/ord/api/subscription/executions/subscribe",
    requestHeaderId: "executions-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "executions-subscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              qOrderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The ID for the created order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              This uniquely identifies an order for reference, tracking,
              order-modification, and cancellation.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              price
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The price at which the order is created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              side
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The side for the order, including Buy or Sell.
            </MDTypography>
          ),
        },

        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              text
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              More details for the locate requested.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              transactTime
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The time of the transaction.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordStatus
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies the status:
                <ul className="bullets">
                  <li>"1"</li>
                  <li>"2"</li>
                </ul>
                where, 1= Partially filled, 2= Filled
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Decimal"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.10
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execBroker
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The executing broker.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.11
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              timeInForce
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                Specifies how long an order remains in effect. Valid values:
                <ul className="bullets">
                  <li>"0"</li>
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                  <li>"5"</li>
                  <li>"6"</li>
                </ul>
                where, 0=Day, 1=DTC, 2=OPG, 3=IOC, 4=FOK, 5=GTX, 6=GTD.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.12
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              ordType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The type of order to be updated. Valid values:
                <ul className="bullets">
                  <li>"1"</li>
                  <li>"2"</li>
                  <li>"3"</li>
                  <li>"4"</li>
                </ul>
                where, 1=Market, 2=Limit, 3=Stop, 4=Stop limit.
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.13
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              orderQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of an order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.14
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              origClOrdID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              FIX client order ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.15
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execRefID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Execution reference ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.16
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              lastPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Last price is execution price.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.17
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execID
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Execution ID.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.18
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies the execution type.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.19
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execTransType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies the execution transaction type.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.20
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execTransTypeDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The description of the execution transaction type.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.21
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              leavesQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Unfilled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.22
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              lastShares
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The quantity of the executed order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.23
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              cumQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Total filled quantity.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.24
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Average price of the order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.25
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              tradeDate
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The date of trade.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.26
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"DateTime"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.27
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              sideDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Description for the side of an order.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.28
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              destination
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Destination using which the order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.29
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the order was created.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.30
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              rule80A
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Rule80A code indicating account classification for reporting.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "executions-subscribe-error",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Executions Unsubscribe
  {
    mainGridId: "executions-unsubscribe",
    subHeading: "Executions Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending execution updates to Socket. Users will stop receiving updates on the execution of orders.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "executions-unsubscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/subscription/executions/unsubscribe",
    requestHeaderId: "executions-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "executions-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "A successful request shows the message, “Success!” with the respective HTTP status code. ",
    respBodyErrorId: "executions-unsubscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Positions Subscribe
  {
    mainGridId: "positions-subscribe",
    subHeading: "Positions Subscribe",
    subHeadingDesc:
      "The Subscribe endpoint will send users the positions' updates from the Socket. The successful return of this API endpoint will give users the current state of the positions. ",
    subHeadingDesc2: (
      <>
        The Socket will receive updates through the
        <span className="staus-code">"Positions"</span> method.
      </>
    ),
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "positions-subscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/subscription/positions/subscribe",
    requestHeaderId: "positions-subscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "positions-subscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventType
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Enum"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Specifies event types. The enum values are as follows:
              <br />
              -1 = current state of the object
              <br />
              0 = empty state of the object
              <br />
              1 = updated state of the object
              <br />
              2 = deleted state of the object
              <br />
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              eventData
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Array"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The array of objects.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbol
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol for which the position exists.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              symbolSfx
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The symbol suffix for which the order is placed.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.3
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              positionString
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <>
                The current position. Valid values:
                <ul className="bullets">
                  <li>Flat</li>
                  <li>Long</li>
                  <li>Short</li>
                </ul>
              </>
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.4
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              avgPrice
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The average price of the position.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.5
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              totDollarOfTrade
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Cost of the users current position.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.6
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              realizedPnL
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The profit and loss that has been realized.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.7
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              execQty
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Double"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              Current position of a stock.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.8
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              originatingUserDesc
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The user who performs the actions.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2.9
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              account
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The account for which the order was created.
            </MDTypography>
          ),
        },
      ],
    },
    respBodyErrorId: "positions-subscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
  },
  // Positions Subscribe Data
  {
    mainGridId: "positions-unsubscribe",
    subHeading: "Positions Unsubscribe",
    subHeadingDesc:
      "The Unsubscribe endpoint will stop sending positions' updates to Socket. Users will stop receiving updates on the positions.",
    endPointHeading: "Request Endpoint",
    endPointMethod: "GET",
    endPointId: "positions-unsubscribe-endpoint",
    endPointDesc: "<base_url>/ext/ord/api/subscription/positions/unsubscribe",
    requestHeaderId: "positions-unsubscribe-headers",
    requestHeader: "Request Headers",
    requestHeaderTableData,
    respBodyId: "positions-unsubscribe-success",
    respBody: "Response Body",
    respBodySuccessStatusCode: "Status Code: 200 (Success)",
    respBodySuccessDesc:
      "	A successful request shows the message, “Success!” with the respective HTTP status code.",
    respBodyErrorId: "positions-unsubscribe-bad-request",
    respBodyErrorStatusCode: "Status Code: 400 (Bad Request)",
    respBodyErrorDesc:
      "A bad request shows an error message with a bad request HTTP status code.",
  },
  // Web Socket Hub
  {
    SampleCode: true,
    index: 0,
    mainHeading: "Web Socket Hub",
    mainGridId: "web-socket-hub",
    mainHeadingDesc:
      "Users can connect to Web Socket Hub to receive real-time transaction notifications.",
    endPointHeading: "Handshake Endpoint",
    endPointMethod: "URL",
    endPointId: "web-socket-hub-endpoint",
    endPointDesc:
      "wss://<base_url>/transactionalws",
    warningNote:
      "Passing the access token as a query parameter ({{?access_token=...}}) is no longer supported due to security concern (token exposure in server logs, browser history, and referrer headers). Use the {{x-access-token}} header or {{access_token}} cookie instead.",
    authHeading: "Authentication",
    authDesc:
      "The server evaluates credentials in the following priority order for WebSocket requests:",
    authTable: {
      columns: [
        { Header: "Priority", accessor: "priority", align: "left", width: "10%" },
        { Header: "Method", accessor: "method", align: "left", width: "30%" },
        { Header: "Description", accessor: "description", align: "left" },
      ],
      rows: [
        {
          priority: (
            <MDTypography component="p" variant="button" color="text" fontWeight="regular">
              1
            </MDTypography>
          ),
          method: (
            <MDTypography component="p" variant="button" color="text" fontWeight="regular">
              x-access-token header
            </MDTypography>
          ),
          description: (
            <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
              Custom header for WebSocket requests when the Authorization header is not available.
            </MDTypography>
          ),
        },
        {
          priority: (
            <MDTypography component="p" variant="button" color="text" fontWeight="regular">
              2
            </MDTypography>
          ),
          method: (
            <MDTypography component="p" variant="button" color="text" fontWeight="regular">
              access_token cookie
            </MDTypography>
          ),
          description: (
            <MDTypography component="p" variant="caption" color="text" fontWeight="regular">
              Cookie-based fallback for WebSocket requests. The JWT is read from an access_token cookie.
            </MDTypography>
          ),
        },
      ],
    },
    cookieNote: (
      <>
        <strong>Cookie Constraints:</strong>
        <ul className="bullets">
          <li>Cookie value must not be empty.</li>
          <li>Cookie value must not exceed 16 KB (DoS protection).</li>
        </ul>
      </>
    ),
    respBodyId: "wse-message-format",
    respBody: "Message Format",
    respBodyTable: {
      columns: [...bodyColumnHeaders],
      rows: [
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              1
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Method
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"String"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The method name is identified by the type of subscription like
              l1, l2, etc.
            </MDTypography>
          ),
        },
        {
          num: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              2
            </MDTypography>
          ),
          field: (
            <MDTypography
              component="p"
              variant="button"
              color="text"
              fontWeight="regular"
            >
              Data
            </MDTypography>
          ),
          datatype: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              <MDBadge
                color="success"
                badgeContent={"Object"}
                variant="gradient"
                size="sm"
              ></MDBadge>
            </MDTypography>
          ),
          description: (
            <MDTypography
              component="p"
              variant="caption"
              color="text"
              fontWeight="regular"
            >
              The data type for this property will be identified by the type of
              subscription.
            </MDTypography>
          ),
        },
      ],
    },
    SampleCodeTitle: "Sample Code (Header-Based Auth)",
    SampleCodeSubTitle: "NodeJS Client",
    SampleCodeId: "wse-sample-code",
  },
  {
    staticData: true,
    mainHeading: "Sample Flow",
    mainGridId: "sample-flow",
    mainHeadingDesc:
      "This sample flow shows users how to request access tokens with Postman and use that token for creating orders, subscribing to orders, and receiving order updates from the Socket.",
    imgIndex: -1,
  },
  {
    staticData: true,
    subHeading: "Step 1:",
    subHeadingDesc:
      "Request access token with Postman by defining body x-www-form-urlencoded and in response, users receive an access token which they can use for other protected APIs in Step 2.",
    imgIndex: 0,
  },
  {
    staticData: true,
    subHeading: "Step 2:",
    subHeadingDesc:
      "Use the access token in the authorization section by selecting Authorization Type as Bearer Token.",
    imgIndex: 1,
  },
  {
    staticData: true,
    imgIndex: 2,
    subHeading: "Step 3:",
    subHeadingDesc: `After entering the access token in the Authorization Header, users can request to create an order by selecting Body as an application/JSON and writing the requested body in JSON. A notification will pop up with status code 200: "Order successfully created," will appear. In the next step, users can subscribe to the orders.`,
  },
  {
    staticData: true,
    subHeading: "Step 4:",
    subHeadingDesc:
      "Users can subscribe to view the current state of the order created in Step 3 and the rest of the updates that users can receive from the Socket as mentioned above.",
    imgIndex: 3,
  },
  // {
  //   staticData: true,
  //   mainHeading: "Support",
  //   mainGridId: "support",
  //   mainHeadingDesc: "For API support, please contact",
  //   supportEmail: "webomsapi@vcttechnologiesllc.com",
  // },
  {
    staticData: true,
    mainHeading: "Disclaimer and Confidentiality Notice",
    mainGridId: "disclaimer-and-confidentiality-notice",
    mainHeadingDesc:
      "The information contained in these documents is confidential, privileged, and only for the information of the intended, recipient and may not be used, published, or redistributed without the prior written consent of VCT Technologies LLC.",
    mainHeadingDesc2:
      "The information is provided with care in this document, VCT Technologies LLC makes no representations and gives no warranties of whatever nature in respect of these documents, including but not limited to the accuracy or completeness of any information, facts, and/or opinions contained therein. VCT Technologies LLC, its subsidiaries, the directors, employees, and agents cannot be held liable for the use and reliance of the information provided in these documents.",
  },
];

export const TableData2 = {
  websockparamcol: [
    { Header: "S/N", accessor: "num", align: "left", width: "5%" },
    {
      Header: "Query Param Name",
      accessor: "qpns",
      align: "left",
      width: "20%",
    },
    { Header: "", accessor: "datatype", align: "left", width: "10%" },
    { Header: "Description", accessor: "desc", align: "left" },
  ],

  websockparamrow: [
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          1
        </MDTypography>
      ),
      qpns: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          access_token
        </MDTypography>
      ),
      datatype: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          <MDBadge
            color="success"
            badgeContent={"String"}
            variant="gradient"
            size="sm"
          ></MDBadge>
        </MDTypography>
      ),
      desc: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          The access token which users receive from the{" "}
          <a href="#authorizations">login API</a>.
        </MDTypography>
      ),
    },
  ],

  websocksmgcol: [...bodyColumnHeaders],

  websocksmgrow: [
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          1
        </MDTypography>
      ),
      field: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          method
        </MDTypography>
      ),
      datatype: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          <MDBadge
            color="success"
            badgeContent={"String"}
            variant="gradient"
            size="sm"
          ></MDBadge>
        </MDTypography>
      ),
      description: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          The method name identifies the type of subscription like
          <br /> "NetLimitSummary," "Orders," "OpenOrders," etc.
        </MDTypography>
      ),
    },
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          2
        </MDTypography>
      ),
      field: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          data
        </MDTypography>
      ),
      datatype: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          <MDBadge
            color="success"
            badgeContent={"Object"}
            variant="gradient"
            size="sm"
          ></MDBadge>
        </MDTypography>
      ),
      description: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          The data type for this property will be identified by the type of
          subscription.
        </MDTypography>
      ),
    },
  ],

  websockircol: [...bodyColumnHeaders],

  websockirrow: [
    {
      num: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          1
        </MDTypography>
      ),
      field: (
        <MDTypography
          component="p"
          variant="button"
          color="text"
          fontWeight="regular"
        >
          accessTokenFactory
        </MDTypography>
      ),
      datatype: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          <MDBadge
            color="success"
            badgeContent={"Method"}
            variant="gradient"
            size="sm"
          ></MDBadge>
        </MDTypography>
      ),
      description: (
        <MDTypography
          component="p"
          variant="caption"
          color="text"
          fontWeight="regular"
        >
          The access token which users receive from the{" "}
          <a href="#request-access-token-request-endpoint">login API.</a>
        </MDTypography>
      ),
    },
  ],
};

export default tradingApiData;
